import { AlertTriangle, CheckCircle2, Clock, XCircle } from "lucide-react";

export const STATUS_META = {
  visa_free: {
    label: "Visa Free",
    className:
      "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
    icon: CheckCircle2,
    dot: "bg-emerald-500",
  },
  visa_on_arrival: {
    label: "Visa on Arrival",
    className:
      "bg-cyan-50 text-cyan-700 border-cyan-200 dark:bg-cyan-950/40 dark:text-cyan-300 dark:border-cyan-800",
    icon: Clock,
    dot: "bg-cyan-500",
  },
  evisa: {
    label: "eVisa Required",
    className:
      "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
    icon: AlertTriangle,
    dot: "bg-amber-500",
  },
  visa_required: {
    label: "Visa Required",
    className:
      "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800",
    icon: XCircle,
    dot: "bg-rose-500",
  },
};

export function getStatusMeta(status) {
  return STATUS_META[status] || STATUS_META.visa_required;
}
